module.exports = __webpack_public_path__ + "static/img/2.4c11660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/2.png
// module id = lcd1
// module chunks = 0